import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import prepareAuthHeaders from "@utils/prepareAuthHeaders";
import { PageResponse } from "@models/page-response";
import { Person } from "@models/person";

const BASE_API_URL = process.env.REACT_APP_API_URL;

export const personApi = createApi({
  reducerPath: "personApi",
  baseQuery: fetchBaseQuery({
    baseUrl: `${BASE_API_URL}/persons`,
    prepareHeaders: prepareAuthHeaders,
  }),
  tagTypes: ["Person"],
  endpoints: (builder) => ({
    getPersons: builder.query<PageResponse<Person>, string>({
      providesTags: ["Person"],
      query: (patientId: string) => {
        return {
          url: ``,
          method: "GET",
          params: {
            patientId,
          },
        };
      },
    }),
  }),
});

export const { useGetPersonsQuery } = personApi;
